(function () {
  'use strict';

  // How often the count drifts up or down (ms)
  var DRIFT_INTERVAL = 7000;

  // Max single-step drift amount
  var DRIFT_STEP = 1;

  function getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  function initWidget(el) {
    var min = parseInt(el.dataset.min, 10) || 7;
    var max = parseInt(el.dataset.max, 10) || 28;
    var countEl = el.querySelector('.ia-sp-count');

    if (!countEl) return;

    // Seed a random starting value
    var current = getRandomInt(min, max);
    countEl.textContent = current;

    // Drift slightly every interval to feel live
    setInterval(function () {
      var direction = Math.random() > 0.45 ? 1 : -1;
      current = Math.min(max, Math.max(min, current + (DRIFT_STEP * direction)));
      countEl.textContent = current;
    }, DRIFT_INTERVAL);
  }

  function init() {
    var widgets = document.querySelectorAll('.ia-social-proof');
    widgets.forEach(initWidget);
  }

  // Support Shopify's SPA-style section rendering
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);

})();